
import qs from 'qs'

const fields = [
]

export const queryExhibitionEntryThumbnails = (options: QueryManyOptions) => {
  const sortKey = strapiGetI18nSortKey(options?.locale, 'titles.i18n_string')

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      sort: options?.sort || ['date_start:desc',`${sortKey}:asc`],
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 9,
      },
      fields,
      filters: options?.filters || {
        $and: [
          {
            exhibition_type: {
              $ne: 'permanent'
            }
          },
          {
            date_start: {
              $notNull: true
            }
          }
        ]
      },
      populate: {
        ...queryFragmentCollectionTypeDefault,
        cover_image: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `exhibition-entries?${query}`
}
